import styled from 'styled-components';
import DraggableIcon from 'assets/icon-draggable.svg';
import JobQuestionRow from './JobQuestionRow';
import ReactTooltip from 'react-tooltip';
import { ReactComponent as DeleteIcon } from 'assets/icons/icon_trash.svg';
import { sortQuestionsAndAttachments } from '../../utils/roleutils';
import React from 'react';
import { JobEditQuestionSet } from './types';

type QuestionSetContainerProps = {
  questionSet: JobEditQuestionSet;
  internalRequirementsSpecified: boolean;
  deleteQuestionRow: () => void;
};

const QuestionSetContainer: React.FC<QuestionSetContainerProps> = ({
  questionSet,
  internalRequirementsSpecified,
  deleteQuestionRow,
}) => {
  return (
    <Container>
      <HeaderContainer>
        <Title>{questionSet.title}</Title>
        <ActionButtonContainer>
          <div style={{ padding: '16px' }}>
            <DeleteButton
              onClick={deleteQuestionRow}
              title="Delete Button"
              data-tip
              data-for="remove-question-set"
            />
          </div>
          <ReactTooltip id="remove-question-set" effect="solid">
            <span>Delete</span>
          </ReactTooltip>
          <DraggableButton src={DraggableIcon} data-tip data-for="reorder-question-set" />
          <ReactTooltip id="reorder-question-set" effect="solid">
            <span>Reorder</span>
          </ReactTooltip>
        </ActionButtonContainer>
      </HeaderContainer>
      {sortQuestionsAndAttachments(questionSet.items).map((question, index) => (
        <div style={{ padding: '8px 0' }} key={index}>
          <JobQuestionRow
            obj={question}
            type={question.question_type}
            internal_requirements_specified={internalRequirementsSpecified}
          />
        </div>
      ))}
    </Container>
  );
};

export default QuestionSetContainer;

const Container = styled.div`
  background: #eeeeee;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 16px;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #000000;
`;

const DraggableButton = styled.img`
  cursor: pointer;
`;

const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
  padding-bottom: 8px;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px 0px;
`;

const DeleteButton = styled(DeleteIcon)<{ title: string }>`
  grid-area: delete-button;
  justify-self: end;
  margin-right: 5px;
  margin-left: 16px;
  margin-top: 2px;
  cursor: pointer;
  min-width: 13px;
`;
